IREP.eventsBand = (function() {
    var eventanimate = function() {
        var eventDisplay = true;
        var eventTarget = $('#eventsMid').offset().top;
        var eventInterval = setInterval(function() {
            if ($(window).scrollTop() + $(window).height() > eventTarget && eventTarget + $('#eventsMid').height() > $(window).scrollTop() && eventDisplay) {
                eventDisplay = false;
                //  TweenMax.staggerFrom($('.eventContainer'), .4, { opacity: 0, left: "300px" }, .10);
                var EventBand_animation = new TimelineMax();
                EventBand_animation
                    .set($("#eventsMid"), { opacity: 1 })
                    .staggerFrom($(".eventContainer"), .25, { opacity: 0, left: "+=100px", ease: Linear.easeNone }, .25)
                    .staggerTo($(".eventContainer"), .15, { left: "+=10px", ease: Linear.easeNone }, 0.25, .25)
                    .staggerTo($(".eventContainer"), .15, { left: "-=10px", ease: Linear.easeNone }, 0.25, .40)

            }
        }, 200);
    };
    
    return {
        eventanimate: eventanimate
    };
})();